import { Typography } from "@mui/material";
// import AWS from "aws-sdk";
import html2pdf from "html2pdf.js";
import moment from "moment";
import { useSelector } from "react-redux";
import CustomTextField from "../../../../components/CustomTextField";
import { productCategoryList } from "../../../../util/dropList";

import { useEffect, useRef } from "react";

// Keep your other imports here...

const MedicalHistoryView = ({ petData, selectedHistory, onUploadComplete }) => {
  const pdfRef = useRef();
  const stocks = useSelector((state) => state?.clinic?.clinicStocks);
  const products = useSelector((state) => state?.clinic?.products);
  const user = localStorage.getItem("user");
  const clinicProfile = JSON.parse(user);

  // AWS.config.update({
  //   accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  //   secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  //   region: process.env.REACT_APP_AWS_REGION,
  // });

  // const s3 = new AWS.S3();
  // const bucketName = process.env.REACT_APP_AWS_BUGET_NAME;

  const generateAndUploadPdf = async () => {
    const element = pdfRef.current;

    if (!element) return;

    const opt = {
      margin: 0.5,
      filename: `${petData?.petName}-${Date.now()}.pdf`,
      image: { type: "pdf", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf().from(element).set(opt).outputPdf("blob");
      onUploadComplete?.("", selectedHistory?.appointmentId, null);
      // const params = {
      //   Bucket: bucketName,
      //   Key: `${petData?.petName}-${Date.now()}.pdf`,
      //   Body: pdfBlob,
      //   ContentType: "application/pdf",
      // };

      // s3.upload(params, (err, data) => {
      //   if (err) {
      //     // console.error("Error uploading to S3:", err);
      //     onUploadComplete?.(null, selectedHistory?.appointmentId, err);
      //   } else {
      //     // console.error("data?.Location",data?.Location, "selectedHistory?.appointmentId",selectedHistory?.appointmentId);
      //     onUploadComplete?.(
      //       data?.Location,
      //       selectedHistory?.appointmentId,
      //       null
      //     );
      //   }
      // });
    } catch (error) {
      console.log("PDF generation or upload failed:", error);
      onUploadComplete?.(null, null, error);
    }
  };

  useEffect(() => {
    if (!selectedHistory || !petData) return;
    setTimeout(() => {
      generateAndUploadPdf();
    }, 2000);
  }, [selectedHistory, petData]);

  const getPrescription = () => {
    return selectedHistory?.prescription?.length > 0
      ? selectedHistory?.prescription?.reduce((a, b) =>
          a.updatedDate > b.updatedDate ? a : b
        )
      : null;
  };

  const getPresItems = (type, count, det = null) => {
    const filteredList = (
      det ?? getPrescription()
    )?.prescriptionDetails?.filter((pd) => pd?.type === type);
    if (count) return filteredList?.length;

    return filteredList?.length > 0 ? (
      filteredList?.map((li, i) => {
        const currPrd = products?.data?.find((prd) => prd?.name === li?.name);
        return (
          <div className="gray-back-con" key={li?.id}>
            <div className="flex-row">
              <div className="w85Per">
                <div className="flex-row flex-row-wrap">
                  <div className="font-bold fs12 black">{li?.name}</div>
                  <div className="flex-row flex-center ml10">
                    <div className="gray-dot" />
                    <div className="font-medium fs12 black4 ml5">Quantity:</div>
                    <div className="txt-regular fs12 black4 ml3">
                      {li?.quantity ?? li?.qty}{" "}
                      {li?.subUnit === "Unit"
                        ? currPrd?.measurementUnit
                        : currPrd?.subMeasurementUnit}
                    </div>
                  </div>
                  <div className="flex-row flex-center ml10">
                    <div className="gray-dot" />
                    <div className="font-medium fs12 black4 ml5">Dosage:</div>
                    <div className="txt-regular fs12 black4 ml3">
                      {li?.dosage}
                    </div>
                  </div>
                  <div className="flex-row flex-center ml10">
                    <div className="gray-dot" />
                    <div className="font-medium fs12 black4 ml5">Duration:</div>
                    <div className="txt-regular fs12 black4 ml3">
                      {li?.duration} days
                    </div>
                  </div>
                  {li?.meal?.length > 0 ? (
                    <div className="flex-row flex-center ml10">
                      <div className="gray-dot" />
                      <div className="txt-regular fs12 black4 ml5">
                        {li?.meal === "afterMeal"
                          ? "After Meal"
                          : li?.meal === "beforeMeal"
                          ? "Before Meal"
                          : ""}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              {li?.morning ||
              li?.afternoon ||
              li?.night ||
              li?.frequencyDuration?.length > 0 ? (
                <div className="blue-back-con fs12 font-medium">
                  {!li?.morning && !li?.afternoon && !li?.night
                    ? li?.frequencyDuration
                    : `${li?.morning ? "1" : "0"}-${
                        li?.afternoon ? "1" : "0"
                      }-${li?.night ? "1" : "0"}`}
                </div>
              ) : null}
            </div>
          </div>
        );
      })
    ) : (
      <div className="no-rec">No records available</div>
    );
  };

  const getListDataToShow = (pl) => {
    return (
      productCategoryList?.length > 0 &&
      productCategoryList?.map((cat, i) => {
        return getPresItems(cat?.value, true, pl) > 0 ? (
          <div key={Date.now() + i}>
            <div className="font-bold fs14 blue-color mv10">{cat?.value}</div>
            {getPresItems(cat?.value, false, pl)}
          </div>
        ) : null;
      })
    );
  };

  const getPrescriptions = () => {
    return selectedHistory?.prescription?.filter(
      (pl) => pl?.appointmentId === selectedHistory?.appointmentId
    );
  };

  const getSelectedClinicalNote = (getAll = false) => {
    const reqRec = selectedHistory?.clinicalNotes?.filter(
      (not) => not?.appointmentId === selectedHistory?.appointmentId
    );
    return reqRec?.length > 0 ? (getAll ? reqRec : reqRec?.[0]) : null;
  };

  const getBatchDetail = (stockId, batchId) => {
    if (!stockId && !batchId) return null;
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    const filteredBatches = reqStock?.stockBatch?.find(
      (btch) => btch?.batchId === batchId
    );
    return filteredBatches;
  };

  const getPreventiveByType = (typ) => {
    return (
      selectedHistory?.prevetive?.filter((pre) =>
        pre?.type?.toLowerCase() === "vaccines"
          ? "vaccination"
          : pre?.type?.toLowerCase() === typ
      ) ?? []
    );
  };

  const renderRecord = (list) => {
    return list?.map((li, i) => {
      const batchDet = getBatchDetail(li?.stockId, li?.batchId) ?? null;

      return (
        <div className="gray-back-con1 mv5" key={Date.now() + i}>
          <div className="flex-row-ali-cen flex-row-wrap">
            <Typography className="txt-semi-bold black fs12">
              Product Name: {li?.name}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Batch No:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {batchDet?.batchNo ?? ""}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Mfg Date:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {moment(batchDet?.mfgDate ?? new Date()).format("DD MMM YYYY")}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Exp Date:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {moment(batchDet?.expiryDate ?? new Date()).format("DD MMM YYYY")}
            </Typography>
          </div>
          <div className="flex-row-ali-cen mt5 flex-row-wrap">
            <div className="gray-dot2 mr5" />
            <Typography className="font-medium black4 fs12">
              Administered date & by:
            </Typography>
            <div className="flex-row">
              <Typography className="txt-regular black4 fs12 ml5 capitalize">
                {moment(new Date(li?.date)).format("DD MMM YYYY")}
              </Typography>
              {li?.doctorName?.length > 0 ? (
                <div className="flex-row">
                  <div className="txt-regular black4 fs12 ml5 capitalize">
                    | {li?.doctorId === li?.clinicId ? "" : "Dr. "}
                    {li?.doctorName}
                  </div>
                  {li?.registrationNo?.length > 0 ? (
                    <div className="flex-row-ali-cen">
                      <div className="font-regular fs12 black ml5">(</div>
                      <div className="font-medium black4 fs12 ml2">RegNo:</div>
                      <div className="font-regular fs12 black ml5 capitalize">
                        {li?.registrationNo} )
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div style={{ display: "none" }}>
      <div className="bg ph20" ref={pdfRef}>
        <div className="flex-row-ali-cen">
          <div className="w15Per">
            <div>
              <div className="flex-center">
                <img src={clinicProfile?.image} alt="" className="img-h50" />
              </div>
            </div>
          </div>
          <div className="w70Per flex-center">
            <div className="flex-column">
              <Typography className="flex-center blue-color font-bold fs18">
                Medical History
              </Typography>
            </div>
          </div>
          <div className="w15Per">
            <div className="flex-end">
              <div className="blu-back wh50 flex-center">
                <img
                  src={require("../../../../assets/images/png/VetInstantLogo.png")}
                  alt=""
                  className="img-hw40"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="br4brblue mt20">
          <div className="p10">
            <div className="flex-row-ali-cen">
              <Typography className="blue-color font-bold fs12 capitalize">
                Clinic Name:
              </Typography>
              <Typography className="txt-regular black fs12 ml5">
                {clinicProfile?.name}
              </Typography>
            </div>
            <div className="flex-row-ali-cen">
              <div className="w33Per">
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12 capitalize">
                    Pet Name:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5">
                    {petData?.petName}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12">
                    Breed:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5 capitalize">
                    {petData?.breed}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12">
                    Vet Name:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5 capitalize">
                    {`${selectedHistory?.doctorName}, ${moment(
                      selectedHistory?.appointmentTime
                    ).format("DD MMM YYYY, HH:mm")}`}
                  </Typography>
                </div>
              </div>
              <div className="w33Per">
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12">
                    Gender:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5 capitalize">
                    {petData?.gender}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12">
                    DOB:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5">
                    {moment(petData?.dob).format("DD MMM YYYY")}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12">
                    Consultation Type:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5 capitalize">
                    {selectedHistory?.appointmentType === "Home"
                      ? "Home Visit"
                      : selectedHistory?.appointmentType}
                  </Typography>
                </div>
              </div>
              <div className="w33Per">
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12 capitalize">
                    Parent Name:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5">
                    {petData?.userName}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12">
                    Contact:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5">
                    {petData?.userMobile}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="blue-color font-bold fs12">
                    Reason for Visit:
                  </Typography>
                  <Typography className="txt-regular black fs12 ml5">
                    {Array.isArray(selectedHistory?.reason)
                      ? selectedHistory?.reason?.join(", ")
                      : ""}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>

        {getSelectedClinicalNote(true)?.length > 0
          ? getSelectedClinicalNote(true)?.map((cn, i) => (
              <div className="mv10" key={`${cn?.id}-${i}`}>
                <div>
                  <div className="flex-row-ali-cen">
                    <div className="heading-fw600 fs14 black">Diagnosis</div>
                    {cn?.tag && (
                      <Typography className="font-medium fs10 card-time blu-back white-color ml10">
                        {cn?.tag}
                      </Typography>
                    )}
                  </div>
                </div>
                <div className="flex-row-ali-cen mt20">
                  <div className="w15Per">
                    <div className="flex-column flex-center mb20">
                      <div className="txt-regular fs40 gray19">S</div>
                      <div className="txt-semi-bold gray19 fs12">
                        Subjective
                      </div>
                    </div>
                  </div>
                  <div className="w85Per">
                    <div className="flex-center">
                      <div className="w100Per">
                        <CustomTextField
                          value={cn?.subjective}
                          fullWidth
                          multiline
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-row-ali-cen mt20">
                  <div className="w15Per">
                    <div className="flex-column flex-center mb20">
                      <div className="txt-regular fs40 gray19">O</div>
                      <div className="txt-semi-bold gray19 fs12">Objective</div>
                    </div>
                  </div>
                  <div className="w85Per">
                    <div className="flex-center">
                      <div className="w100Per">
                        <CustomTextField
                          value={cn?.objective}
                          fullWidth
                          multiline
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-row-ali-cen mt20">
                  <div className="w15Per">
                    <div className="flex-column flex-center mb20">
                      <div className="txt-regular fs40 gray19">A</div>
                      <div className="txt-semi-bold gray19 fs12">
                        Assessment
                      </div>
                    </div>
                  </div>
                  <div className="w85Per">
                    <div className="flex-center">
                      <div className="w100Per">
                        <CustomTextField
                          value={cn?.assessment}
                          fullWidth
                          multiline
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-row-ali-cen mt20">
                  <div className="w15Per">
                    <div className="flex-column flex-center mb20">
                      <div className="txt-regular fs40 gray19">P</div>
                      <div className="txt-semi-bold gray19 fs12">Plan</div>
                    </div>
                  </div>
                  <div className="w85Per">
                    <div className="flex-center">
                      <div className="w100Per">
                        <CustomTextField
                          value={cn?.plan}
                          fullWidth
                          multiline
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt20">
                  <div className="flex-row-between-align-center">
                    <div className="heading-fw600 fs14 black">Conclusion</div>
                  </div>
                  <div className="text400 mt10 p15 back-white cli-not-box">
                    {cn?.conclusion}
                  </div>
                </div>
                <div className="mt20">
                  <div className="flex-row-between-align-center">
                    <div className="heading-fw600 fs14 black">Key Issues</div>
                  </div>
                  <div className="text400 mt10 p15 back-white cli-not-box">
                    {cn?.keyIssues}
                  </div>
                </div>
                <div className="mt20">
                  <div className="flex-row-between-align-center">
                    <div className="heading-fw600 fs14 black">
                      Abnormal Findings
                    </div>
                  </div>
                  <div className="text400 mt10 p15 back-white cli-not-box">
                    {cn?.abnormalFindings}
                  </div>
                </div>
                <div className="mt20">
                  <div className="flex-row-between-align-center">
                    <div className="heading-fw600 fs14 black">
                      Customer Instructions
                    </div>
                  </div>
                  <div className="text400 mt10 p15 back-white cli-not-box">
                    {cn?.customerInstructions}
                  </div>
                </div>
              </div>
            ))
          : null}

        <div className="br4brblue mt20">
          <div className="p10">
            <div>
              <Typography className="font-bold blue-color fs14 mv5">
                Vaccination
              </Typography>
              {getPreventiveByType("vaccination")?.length > 0 ? (
                renderRecord(getPreventiveByType("vaccination"))
              ) : (
                <div className="no-rec">No records available</div>
              )}
            </div>

            <div>
              <Typography className="font-bold blue-color fs14 mv5">
                Deworming
              </Typography>
              {getPreventiveByType("deworming")?.length > 0 ? (
                renderRecord(getPreventiveByType("deworming"))
              ) : (
                <div className="no-rec">No records available</div>
              )}
            </div>

            <div>
              <Typography className="font-bold blue-color fs14 mv5">
                Flea Treatment
              </Typography>
              {getPreventiveByType("fleatreatment")?.length > 0 ? (
                renderRecord(getPreventiveByType("fleatreatment"))
              ) : (
                <div className="no-rec">No records available</div>
              )}
            </div>
          </div>
        </div>

        {getPrescriptions()?.length ? (
          getPrescriptions()?.map((pl, i) => (
            <div className="pv10" key={`${pl?.prescriptionId}-${i}`}>
              <div className="blue-box-examD mt20">
                {getListDataToShow(pl)}
                <div className="font-bold fs14 blue-color mv10">Advice</div>
                <CustomTextField
                  fullWidth
                  multiline
                  placeholder="Advice"
                  rows={3}
                  value={pl?.remark ?? ""}
                  disabled
                />
              </div>
            </div>
          ))
        ) : (
          <div className="no-rec h100">No records available</div>
        )}

        <div className="br4brblue mt20">
          <div className="p10">
            <div>
              {selectedHistory?.diagnostics?.length > 0 ? (
                selectedHistory?.diagnostics?.map((li, i) => (
                  <div
                    className="gray-back-con1 mv5"
                    key={`${li?.diagonosticId}-${i}`}
                  >
                    <div className="flex-row-ali-cen flex-row-wrap">
                      <Typography className="txt-semi-bold black fs12">
                        Name: {li?.type}
                      </Typography>
                      <div className="gray-dot2 mh5" />
                      <Typography className="font-medium black4 fs12">
                        Due Date:
                      </Typography>
                      <Typography className="txt-regular black4 fs12 ml5">
                        {moment(li?.dueDate ?? new Date()).format(
                          "DD MMM YYYY"
                        )}
                      </Typography>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-rec">No records available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicalHistoryView;
